"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deFat = exports.Fat = void 0;
var react_1 = __importDefault(require("react"));
var identity = function (str) { return str; };
var Fat = function (_a) {
    var id = _a.id, post = _a.post;
    // TODO: add debug mode
    return react_1.default.createElement(react_1.default.Fragment, null, (0, exports.deFat)(id, post));
};
exports.Fat = Fat;
var deFat = function (id, post) {
    var postProcess = post || identity;
    // not a fat string
    if (!(id || "").startsWith("fat:")) {
        return postProcess(id);
    }
    var global = globalThis;
    var lang = global.UILanguage || "ja-JP";
    var translations = global.translations || {};
    var ja = translations["ja-JP"] || {};
    var translation = translations[lang] || {};
    var index = id.split("fat:")[1] || "";
    var translated = translation[index];
    if (!translated && translated !== "") {
        console.warn("Translation not found for ".concat(index, ", japanese: \"").concat(ja[index], "\""));
    }
    return postProcess(translated || "");
};
exports.deFat = deFat;
